import { t } from '@/utils/i18n'

const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_API_FORMAT = 'YYYY-MM-DD'; // 这种格式一般用于接口请求的日期参数


export default {
  REQUEST_EXPIRED: t('请求已过期'),
  DATE_TIME_FORMAT,
  DATE_FORMAT,
  DATE_API_FORMAT
};
